import React, { useMemo } from 'react';
import NextStepsCommon from './NextStepsCommon';
import { useI18n } from 'next-localization';
import { usePageData } from 'lib/page-data/PageDataContext';
import { ComponentProps } from 'lib/component-props';
import { useSitecoreContext } from 'hooks/useSitecoreContext';

type NextStepsProps = ComponentProps & {
  className?: string;
};

const NextSteps: React.FC<NextStepsProps> = ({ rendering, params, className }) => {
  const { t } = useI18n();

  const context = useSitecoreContext();

  const { articleData } = usePageData('article') ?? {};

  const relatedCapabilitiesLength = articleData?.articleCapabilities?.targetItems.length ?? 0;

  const passThroughProps = useMemo(() => {
    return {
      rendering,
      params,
      className,
      title: t('nextSteps'),
      subtitle: t('nextStepsTitle'),
      description: t('nextStepsDescription'),
      placeholderName: 'abrdn-article-next-steps-content',
    };
  }, [className, params, rendering, t]);

  return (
    (relatedCapabilitiesLength > 0 || context.sitecoreContext.pageEditing) && (
      <NextStepsCommon {...passThroughProps} />
    )
  );
};

export default NextSteps;
